module.exports = __webpack_public_path__ + "static/img/activity_sdy_03-3.d5b95cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_03-3.jpg
// module id = QkZG
// module chunks = 0